import { useCallback, useEffect, useRef, useState } from "react";
import uuid from "../../mixins/uuid";
var roots = new Map();
var observers = {};
var totalObservers = {};
var callbacks = new Map();
var getRootId = function (root) {
    if (roots.has(root))
        return roots.get(root);
    var id = uuid();
    roots.set(root, id);
    return id;
};
var getId = function (_a) {
    var root = _a.root, rootMargin = _a.rootMargin, threshold = _a.threshold;
    return getRootId(root) + "|" + rootMargin + "|" + threshold;
};
var intersectionCallback = function (entries) {
    entries.forEach(function (entry) {
        var target = entry.target, isIntersecting = entry.isIntersecting;
        callbacks.get(target)(isIntersecting);
    });
};
var observe = function (callback, element, options) {
    var id = getId(options);
    if (!(id in observers)) {
        observers[id] = new IntersectionObserver(intersectionCallback, options);
        totalObservers[id] = 0;
    }
    var observer = observers[id];
    observer.observe(element);
    callbacks.set(element, callback);
    totalObservers[id] = totalObservers[id] + 1;
    return function () {
        callbacks.delete(element);
        observer.unobserve(element);
        totalObservers[id] = totalObservers[id] - 1;
        if (totalObservers[id] > 0)
            return;
        observer.disconnect();
        callbacks.delete(callback);
        delete observers[id];
        delete totalObservers[id];
    };
};
export default (function (_a) {
    var root = _a.root, rootMargin = _a.rootMargin, threshold = _a.threshold, onVisibility = _a.onVisibility;
    var ref = useRef();
    var unObserveRef = useRef();
    var _b = useState(false), visible = _b[0], setVisible = _b[1];
    var setRef = useCallback(function (element) {
        var _a;
        ref.current = element;
        (_a = unObserveRef.current) === null || _a === void 0 ? void 0 : _a.call(unObserveRef);
        unObserveRef.current = null;
        if (!element)
            return;
        var options = { root: root, rootMargin: rootMargin, threshold: threshold };
        unObserveRef.current = observe(function (value) {
            if (onVisibility)
                onVisibility(value);
            setVisible(value);
        }, element, options);
    }, [root, rootMargin, threshold]);
    useEffect(function () { return function () {
        var _a;
        (_a = unObserveRef.current) === null || _a === void 0 ? void 0 : _a.call(unObserveRef);
        unObserveRef.current = null;
    }; }, []);
    return [setRef, ref, visible];
});
